import { AbstractControl } from '@angular/forms';
import * as brainTreeCardValidator from 'card-validator';

/**
 * Custom validator for paymethod form
 * @param control
 */
export function PaymethodFormValidator(control: AbstractControl) {
    const cardNumber = control.get('cardNumber') ? control.get('cardNumber')?.value : '';
    const cardCvv = control.get('cvv') ? control.get('cvv')?.value : '';
    const cardExpiry = control.get('expiry') ? control.get('expiry')?.value : '';

    const cardType = brainTreeCardValidator.number(cardNumber).card;

    const errors: any = {};

    if (cardType && cardType.type) {
        if (!brainTreeCardValidator.number(cardNumber).isValid) {
            // to catch the additional symbol
            if (!brainTreeCardValidator.number(cardNumber.slice(0, cardNumber.length - 1)).isValid) {
                errors.cardNumber = true;
            } else {
                control.get('cardNumber')?.setValue(cardNumber.slice(0, cardNumber.length - 1)); // ! check the fs-card-fields the fix for date-picker is better from this. fix when have time
            }
        }

        if (!brainTreeCardValidator.cvv(cardCvv, [cardType.code.size]).isValid) {
            if (!brainTreeCardValidator.cvv(cardCvv.slice(0, cardCvv.length - 1), [cardType.code.size]).isValid) {
                errors.cardCvv = true;
            } else {
                control.get('cvv')?.setValue(cardCvv.slice(0, cardCvv.length - 1));
            }
        }

    } else {
        errors.notSupportedCard = true;
    }

    if (cardExpiry && cardExpiry.length && !brainTreeCardValidator.expirationDate(cardExpiry).isValid) {
        if (cardExpiry.length && !brainTreeCardValidator.expirationDate(cardExpiry.slice(0, cardExpiry.length - 1)).isValid) {
            errors.cardExpiry = true;
        } else {
            control.get('expiry')?.setValue(cardExpiry.slice(0, cardExpiry.length - 1));
        }
    }

    return errors;
}

/**
 * Validator for card number
 * @param cardNumber
 */
export function validateCardNumber(cardNumber: string) {
    return brainTreeCardValidator.number(cardNumber);
}
